import { DBDocSchema, VRCAudioMetadata, VRCAudioMetadataSchema } from '@pwp-common';

import { CreateVRCAudioMetadataInput } from './interfaces';

export const createVRCAudioMetadata = (params: CreateVRCAudioMetadataInput): VRCAudioMetadata => {
  const { audioId, displayName, description } = params;

  return new VRCAudioMetadata({
    [DBDocSchema.id]: audioId,
    [VRCAudioMetadataSchema.displayName]: displayName ?? VRCAudioMetadataSchema.Defaults.displayName,
    [VRCAudioMetadataSchema.description]: description ?? VRCAudioMetadataSchema.Defaults.description,
    [VRCAudioMetadataSchema.audio]: VRCAudioMetadataSchema.Defaults.audio,
    [VRCAudioMetadataSchema.audioNoSpeechRecognition]: VRCAudioMetadataSchema.Defaults.audioNoSpeechRecognition,
    [VRCAudioMetadataSchema.wasProcessedByServer]: VRCAudioMetadataSchema.Defaults.wasProcessedByServer,
  });
};
